import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "iframe-wrapper" }
const _hoisted_2 = { class: "gameBar" }
const _hoisted_3 = ["src"]

import { getGameUrl } from '@/api/game'
import StatusPopup from '@/components/common/statusPopup.vue'
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GameHeadBar from './component/gameHeadBar.vue'
import { toggleFavorite } from './supportScript'
import { useUserStore } from '@/stores/user'
import { useGameStore } from '@/stores/games'


export default /*@__PURE__*/_defineComponent({
  __name: 'gameView',
  setup(__props) {

const router = useRouter()
const route = useRoute();
const GameType = ref<any>(route.query.game_type);
const gameMakerID = ref(route.query.game_maker);
const favId = ref<any>(route.query.fav_id)
const userStore = useUserStore()
const gameStore = useGameStore()
const isFavorite = ref(false)
const favoriteStatus = ref<any>('')
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const iframeUrl = ref("")
const loadingRef = ref()
const navToback = () => {
    router.go(-1)
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const gameUrl = () => {
    let params = {
        gameId: GameType.value,
        gameMakerId: gameMakerID.value
    }
    getGameUrl(params).then(res => {
        let resData = res?.data
        iframeUrl.value = resData?.game_url || ''
        // let resData = res.data.data
        // iframeUrl.value = resData.game_url
    }).catch(err => {
        showError(err);
    })
}

const addToFavorite = () => {
    toggleFavorite({
        userId: userStore.id,
        gameId: favId.value,
        currentStatus: favoriteStatus.value,
        loadingRef,
        onSuccess: (status, msg) => {
            favoriteStatus.value = status
            isFavorite.value = favoriteStatus.value == '1' ? true : false
            gameStore.getGameGroupListData();
        },
        onError: (msg) => {
            showError(msg)
        }
    });
}

onMounted(() => {
    gameUrl()
    favoriteStatus.value = route.query?.favorite
    isFavorite.value = favoriteStatus.value == '1' ? true : false

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(GameHeadBar, {
          onBackClick: navToback,
          "is-favorite": isFavorite.value,
          onAddFavorite: addToFavorite
        }, null, 8, ["is-favorite"])
      ]),
      (iframeUrl.value)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            src: iframeUrl.value,
            frameborder: "0"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})